import { Fragment, useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import AgTypography from '../../../stories/Styles/AgTypography';
import AgBox from '../../AgBox';
import AddIcon from '@mui/icons-material/Add';
import { useIntl } from 'react-intl';
import { AgTheme } from '../../../styles/theme';
import AgDropdown from '../../../stories/AgDropdown';
import AgTextField from '../../../stories/Components/AgTextField';
import AgTextArea from '../../../stories/Components/AgTextArea';
import AgLoadingButton from '../../../stories/AgLoadingButton';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectFullProfile } from '../../../redux/slices/fullProfile';
import { getUsers } from '../../../pages/Search/redux';
import { sendMessages } from '../../../redux/slices/notifications';
import { SUCCESS_STATUS } from '../../../Constants';
import AgIconButton from '../../../stories/AgIconButton';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid',
  borderRadius: '5px',
  borderColor: AgTheme.palette.primary.main,
  boxShadow: 24,
  p: 4
};

export default function AddNotifications() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{
    to?: string[];
    sub?: string;
    msg?: string;
  }>();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setLoading(false);
  };
  const messages = useIntl().formatMessage;
  const profile = useAppSelector(selectFullProfile);
  const dispatch = useAppDispatch();
  const [users, setUsers] = useState<{ name: string; id: number }[]>();

  useEffect(() => {
    try {
      const f = async () => {
        if(!(profile?.organizations && profile.organizations[0].id)) return;
        const response = await dispatch(getUsers(profile?.organizations[0]?.id));
        const data: any = response.data;
        const newUsers = data.map((d: any) => {
          return { name: `${d.firstName} ${d.familyName}`, id: d.id };
        });
        setUsers(newUsers);
      };
      f();
    } catch (error) {
      console.error(error);
    }
  }, [dispatch, profile?.organizations]);

  const clearData = () => {
    setData(undefined);
    setLoading(false);
  };

  const send = async () => {
    const response = await dispatch(
      sendMessages({
        subject: data?.sub,
        body: data?.msg,
        toUsers:
          users
            ?.filter((user) => data?.to?.includes(user.name))
            .map((u) => u.id) || []
      })
    );
    return response.status;
  };

  return (
    <div>
      <AgIconButton icon={<AddIcon />} onClick={() => handleOpen}/>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Fragment>
          <AgBox sx={style}>
            <AgTypography id='modal-modal-title' component='div'>
              {messages({ id: 'NOTIFICATION_SEND' })}
            </AgTypography>
            <AgTypography id='modal-modal-title' component='div'>
              <AgDropdown
                multiple
                disabled={!users}
                values={data?.to || []}
                width={600}
                onChange={(e: string[]) => {
                  const values = users?.filter((l) => e.includes(l.name));
                  setData({ ...data, to: values?.map((v) => v?.name) });
                }}
                placeholder={messages({ id: 'TO' })}
                options={users || []}
              />
            </AgTypography>
            <AgTypography id='modal-modal-title' component='div'>
              <AgTextField
                value={data?.sub || ''}
                placeholder={messages({ id: 'SUBJECT' })}
                onChange={(e) => setData({ ...data, sub: e.target.value })}
              />
            </AgTypography>
            <AgTypography id='modal-modal-title' component='div'>
              <AgTextArea
                value={data?.msg || ''}
                placeholder={messages({ id: 'MESSAGE' })}
                onChange={(e) => setData({ ...data, msg: e.target.value })}
              />
            </AgTypography>
            <AgLoadingButton
              loading={loading}
              disabled={!data?.to || !data?.msg || !data?.sub}
              style={{ float: 'right', marginTop: '1em', marginLeft: '1em' }}
              onClick={async () => {
                setLoading(true);
                const status = await send();
                if (status === SUCCESS_STATUS) clearData();
                handleClose();
              }}
              label={messages({ id: 'SEND' })}
            />
            <AgLoadingButton
              variant='text'
              style={{ float: 'right', marginTop: '1em' }}
              onClick={handleClose}
              label={messages({ id: 'CLOSE' })}
            />
          </AgBox>
        </Fragment>
      </Modal>
    </div>
  );
}
